import component from './Section'
export default component
export * from './Section'